// src/hooks/jobOrders/useExportJobOrderPdf.js
import { useMutation } from "@tanstack/react-query";
import { exportJobOrderToPdf } from "../../api/apiJobOrders";
import toast from "react-hot-toast";

const useExportJobOrderPdf = () => {
    const { mutate: exportJobOrderPdfMutate, isPending, mutateAsync } = useMutation({
        mutationFn: ({ jobOrderId, html, filename, format = "A4", landscape = false }) => {
            return exportJobOrderToPdf(jobOrderId, { html, filename, format, landscape });
        },
        onSuccess: (response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
                "download",
                response.headers["content-disposition"]?.split("filename=")[1]?.replace(/"/g, "") || "JobOrder.pdf"
            );
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
        },
        onError: (error) => {
            const message = error.response?.data?.message || "حدث خطأ أثناء تصدير أمر التشغيل";
            toast.error(message);
        },
    });

    return { exportJobOrderPdfMutate, mutateAsync, isPending };
};

export default useExportJobOrderPdf;
